// Panel-dock strings (English) — merged in ./messages.ts; Spanish in
// ./gameLayoutEs.ts. Kept in their own module so gameEn/gameEs stay under
// the 400-line split rule.

export const gameLayoutEn = {
  // Panel docks (per-player HUD layout)
  'layout.collapsePanel': 'Collapse panel',
  'layout.expandPanel': 'Expand panel',
  'layout.movePanel': 'Drag to move this panel to another dock',
  'layout.resizePanel': 'Resize panel',
  'settings.tab.interface': 'Interface',
  'settings.layout.description':
    'Panels can be dragged to the left, right or bottom dock, resized at their inner edge, and collapsed to a dock rail button. Your arrangement is saved per player.',
  'settings.layout.reset': 'Reset panel layout',
} as const;
